export const totemTypes = {
    cleanOpciones: '[OPCIONES] Clean Opciones Totem',
    getOpciones: '[OPCIONES] Get Opciones Totem',
    insertOpcion: '[OPCIONES] Insert Opcion Totem',
    updateOpcion: '[OPCIONES] Update Opcion Totem',
    deleteOpcion: '[OPCIONES] Delete Opcion Totem',

    cleanSubOpciones: '[SUB OPCIONES] Clean SubOpciones Totem',
    getSubOpciones: '[SUB OPCIONES] Get SubOpciones Totem',
    insertSubOpcion: '[SUB OPCIONES] Insert SubOpcion Totem',
    updateSubOpcion: '[SUB OPCIONES] Update SubOpcion Totem',
    deleteSubOpcion: '[SUB OPCIONES] Delete SubOpcion Totem',

    cleanRecepciones: '[RECEPCIONES] Clean Recepciones Totem',
    getRecepciones: '[RECEPCIONES] Get Recepciones Totem',
    insertRecepcion: '[RECEPCIONES] Insert Recepcion Totem',
    updateRecepcion: '[RECEPCIONES] Update Recepcion Totem',
    deleteRecepcion: '[RECEPCIONES] Delete Recepcion Totem',

    cleanRecepcionesUsuario: '[RECEPCIONES USUARIO] Clean Recepciones Usuario Totem',
    getRecepcionesUsuario: '[RECEPCIONES USUARIO] Get Recepciones Usuario Totem',

    cleanSolicitudesRecepcionesUsuario: '[SOLICITUDES RECEPCIONES USUARIO] Clean Solicitudes Recepciones Usuario Totem',
    getSolicitudesRecepcionesUsuario: '[SOLICITUDES RECEPCIONES USUARIO] Get Solicitudes Recepciones Usuario Totem',
    insertSolicitudRecepcionUsuario: '[SOLICITUDES RECEPCIONES USUARIO] Insert Solicitud Recepcion Usuario Totem',

    cleanSolicitudesAfiliados: '[SOLICITUDES AFILIADOS] Clean Solicitudes Afiliados Totem',
    getSolicitudesAfiliados: '[SOLICITUDES AFILIADOS] Get Solicitudes Afiliados Totem',
    updateSolicitudesAfiliados: '[SOLICITUDES AFILIADOS] Update Solicitudes Afiliados Totem',

    cleanAfiliados: '[AFILIADO] Clean Afiliado Totem',
    getAfiliados: '[AFILIADO] Get Afiliado Totem',

    cleanTurnosAfiliados: '[TURNOS AFILIADO] Clean Turnos Afiliado Totem',
    getTurnosAfiliados: '[TURNOS AFILIADO] Get Turnos Afiliado Totem',
    confirmTurnoAfiliados: '[TURNOS AFILIADO] Confirm Turno Afiliado Totem',

    setActiveBreadcrumbTotem: '[TURNOS AFILIADO] Breadcurmb totem',

    getRecepcionPisos: '[AFILIADO] Get recepcion pisos Totem',
}